__turbopack_context__.v({
  "icon": "eM8JXW_icon",
});
